import { URLSearchParams } from 'node:url';
import { TransportOrdersFilters as TransportOrdersFiltersType } from '../../domain/transportOrdersFilters';

export const buildFiltersFromQuery = (serachParams: URLSearchParams): TransportOrdersFiltersType => {
    let filters: TransportOrdersFiltersType = {};

    const addFilter = (filterToAdd: Partial<TransportOrdersFiltersType>) => {
        filters = {
            ...filters,
            ...filterToAdd,
        };
    };

    const fromMonth = Number(serachParams.get('fromMonth'));
    const fromYear = Number(serachParams.get('fromYear'));
    const toMonth = Number(serachParams.get('toMonth'));
    const toYear = Number(serachParams.get('toYear'));
    const creatorId = serachParams.get('creatorId');
    const contractorId = serachParams.get('contractorId');
    const query = serachParams.get('query');

    if (fromMonth && fromYear) {
        addFilter({
            orderMonthYearRange: {
                fromMonth,
                fromYear,
                toMonth: toMonth || fromMonth,
                toYear: toYear || fromYear,
            },
        });
    }

    if (creatorId) {
        addFilter({ creator: { id: creatorId } });
    }

    if (contractorId) {
        addFilter({ contractor: { id: contractorId } });
    }

    if (query) {
        addFilter({ query: { value: query } });
    }

    return filters;
};

export const buildQueryFromFilters = (filters?: TransportOrdersFiltersType) => {
    let filtersQuery = '';

    const addToFiltersQuery = (filterValue: string) => {
        if (!filtersQuery) {
            filtersQuery = filterValue;
        } else {
            filtersQuery = `${filtersQuery}&${filterValue}`;
        }
    };

    if (filters?.orderMonthYearRange) {
        const { fromMonth, fromYear, toMonth, toYear } = filters.orderMonthYearRange;
        addToFiltersQuery(`fromMonth=${fromMonth}&fromYear=${fromYear}&toMonth=${toMonth}&toYear=${toYear}`);
    }

    if (filters?.creator) {
        addToFiltersQuery(`creatorId=${filters.creator.id}`);
    }

    if (filters?.contractor) {
        addToFiltersQuery(`contractorId=${filters.contractor.id}`);
    }

    if (filters?.query) {
        addToFiltersQuery(`query=${filters.query.value}`);
    }

    return filtersQuery;
};